import React from 'react';
import PropTypes from 'prop-types';

import { LogoToolbar } from '../toolbar';
import { FlatButton } from '../../components/buttons';

const NotFound = ({ history }) => (
  <div>
    <LogoToolbar />
    <div className="row center-xs">
      <div className="col">
        <h1>Not Found</h1>
        <FlatButton label="Go Back" onClick={history.goBack} />
      </div>
    </div>
  </div>
);

NotFound.propTypes = {
  history: PropTypes.object.isRequired,
};

export default NotFound;
